import { Grid } from "@mui/material";
import { FC, useEffect, useState } from "react";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useSoftnetStore } from "../../hooks/useSoftnetStore";
import { ApiStatus } from "../../types/api/status";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";

const columns = [
    { type: 'text', field: 'id', label: 'N°', align: 'center', format: (row, index) => index + 1 },
    { type: 'text', field: 'descripcion', label: 'Descripción', align: 'center' },
    { type: 'checkbox', field: 'checkbox', label: 'checkbox', align: 'center' },
];

const breadcrumbs = [
    { id: 1, label: 'Importaciones' },
    { id: 2, label: 'Importar ERP', pathname: RoutesMap.IMPORT_ERP },
    { id: 2, label: 'Subcategorías', pathname: RoutesMap.IMPORT_SUBCATEGORY }
]

export const ImportSubcategoryERP: FC = () => {
    const navigate = useNavigate()
    const { status, subcategoriesERP, getSubcategoriesERP, importSelectSubcategory } = useSoftnetStore()

    const [selected, setSelected] = useState<any>([])

    useEffect(() => {
        getSubcategoriesERP()
    }, [])

    const onGoBack = () => {
        navigate({ pathname: RoutesMap.IMPORT_ERP })
    }

    const onAddFn = async () => {
        const payload = {
            dataSubcategory: selected
        }
        const response = await importSelectSubcategory(payload)
        if (response === true) setSelected([])
    }

    const selectAll = (event) => {
        if (event.target.checked) {
            const newSelected = subcategoriesERP.map((n) => n)
            setSelected(newSelected)
        } else {
            setSelected([])

        }
    }

    const onCheckbox = (row) => {
        const selectedIndex = selected.findIndex(selectedRow => selectedRow.id === row.id)
        let newSelected = []

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row)
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1))
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1))
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            )
        }
        setSelected(newSelected)
    }

    const isSelected = (row) => {
        return selected.some(item => item.id === row.id)
    }

    return (
        <Grid item xs={12}>
            <CustomTable
                breadcrumbs={breadcrumbs}
                title={'Importar subcategorías del ERP Softnet'}
                columns={columns}
                rows={subcategoriesERP || []}
                loading={status === ApiStatus.FETCHING}
                onRowClick={() => { }}
                // onGoBack={onGoBack}
                onAddFn={onAddFn}
                onAddFnName={'Importar'}
                selectAll={selectAll}
                onCheckbox={onCheckbox}
                isSelected={isSelected}
                hasOptions
                dense
            />
        </Grid>
    )
}